import script from "./PublicHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicHeader.vue?vue&type=script&setup=true&lang=js"

import "./PublicHeader.vue?vue&type=style&index=0&id=c8af3eba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8af3eba"]])

export default __exports__